import * as React from 'react';

export const RadioBullet: React.FC<{
  checked: boolean;
  className?: string;
}> = ({ checked, className = '' }) => (
  <div
    className={`w-4 h-4 rounded-full flex-shrink-0 transition-all ${
      checked ? 'border-primary-400 border-6' : 'border-grey-200 border'
    } ${className}`}
  ></div>
);
